import { render, staticRenderFns } from "./CardDetailsForm.vue?vue&type=template&id=2409566a&scoped=true&"
import script from "./CardDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./CardDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./CardDetailsForm.vue?vue&type=style&index=0&id=2409566a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2409566a",
  null
  
)

export default component.exports